/* SellPC.in — minimal theme JS. No dependencies. */
(function () {
  'use strict';

  /* Mobile navigation ---------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* Reveal panels (e.g. "Include a monitor?") ---------------------------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-reveal]');
    if (!input) return;
    var panel = document.getElementById(input.getAttribute('data-reveal'));
    if (!panel) return;
    panel.classList.toggle('is-open', input.checked);
    panel.querySelectorAll('input, select, textarea').forEach(function (el) {
      el.disabled = !input.checked;
    });
  });

  /* File inputs: show chosen filenames + guard count/size ----------------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('input[type="file"][data-dz]')) return;

    var zone = input.closest('.dropzone');
    if (!zone) return;
    var out = zone.querySelector('.dz-files');
    if (!out) return;

    var max = parseInt(input.getAttribute('data-max') || '0', 10);
    var files = Array.prototype.slice.call(input.files || []);

    if (max && files.length > max) {
      out.textContent = 'Please select no more than ' + max + ' files (you chose ' + files.length + ').';
      input.value = '';
      return;
    }

    out.textContent = files.length
      ? files.length + (files.length === 1 ? ' file selected' : ' files selected')
      : '';
  });

  /* Combo fields: choosing a preset fills the free-text input ------------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-combo-for]');
    if (!select) return;
    var target = document.getElementById(select.getAttribute('data-combo-for'));
    if (target && select.value) {
      target.value = select.value;
      select.selectedIndex = 0;
    }
  });
})();
